import { type ReportTemplate } from 'reportingSolution/constants'

const config: ReportTemplate = {
  id: 'shopping_bestseller_report_v2',
  active: true,
  label: 'Shopping Bestseller Report V2',
  category: 'Product analysis',
  description: 'Analyze bestselling products and brands across Googles advertising network',
  image_url: '-',
  authors: [
    {
      name: 'Precis Digital',
      email: 'support@precisdigital.com',
      image_url: '-'
    }
  ],
  documentation: {
    type: '-',
    link: '-',
    link_description: '-'
  },
  dashboard: {
    template_report_id: '8c089b28-10ba-4ce4-aed8-00df62be916a',
    report_name_template: 'copy of Shopping Bestseller Report V2 - {today}',
    datasources: [
      {
        alias: 'brands',
        datasourceName: 'Bestseller Brands - {name}',
        type: 'TABLE',
        tableId: 'bestseller_brands_{name}',
        isPartitioned: 'true',
        refreshFields: 'false'
      },
      {
        alias: 'products',
        datasourceName: 'Bestseller Products - {name}',
        type: 'TABLE',
        tableId: 'bestseller_products_{name}',
        isPartitioned: 'true',
        refreshFields: 'false'
      }
    ]
  },
  sources: {
    merchant: {
      reports: ['products', 'best_sellers_product_view', 'best_sellers_brand_view']
    },
    gads: {
      reports: ['shopping_insights_base', 'customer_campaign_meta_data']
    }
  },
  inputs: {
    other: [
      {
        id: 'targetCurrency',
        type: 'dropdown',
        label: 'Target Currency',
        defaultValue: 'EUR',
        tooltip: 'The currency to transform all currency-based columns (cost, revenue, etc) to.',
        required: true,
        mutable: true
      }
    ]
  }
}

export default config
